export const normalizeQuoteLabel = (label) => String(label || "").trim().toLowerCase();

export const isCompanyQuoteField = (label) => {
  const normalized = normalizeQuoteLabel(label);
  if (!normalized) return false;
  if (normalized.includes("company")) return true;
  return normalized.includes("carrier");
};

export const isProductQuoteField = (label) => {
  const normalized = normalizeQuoteLabel(label);
  if (!normalized) return false;
  if (normalized === "product" || normalized === "product name") return true;
  return normalized.includes("product");
};

export const isIssueAgeQuoteField = (label) => {
  const normalized = normalizeQuoteLabel(label);
  if (!normalized) return false;
  const collapsed = normalized.replace(/[\s_]+/g, "");
  if (normalized.includes("issue age")) return true;
  return collapsed.includes("issueage");
};

export const getQuoteFieldLabel = (field) => field?.label || field?.quote_field_id || field?.id || "";
